var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoorperatuveBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 206,
    viewBox: "0 0 140 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3453_2822)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 206,
    rx: 20,
    fill: "#626C79"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.785 -23.4535C191.076 -25.8861 204.59 -11.744 198.866 1.74675L143.777 131.581C138.16 144.82 118.152 147.513 107.582 136.451L5.88357 30.0289C-4.68649 18.9678 2.01004 2.34516 17.9979 -0.0421399L174.785 -23.4535Z",
    fill: "url(#paint0_linear_3453_2822)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3453_2822",
    x1: 132.134,
    y1: -130.789,
    x2: 223.654,
    y2: 64.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDD3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9FB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3453_2822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 206,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoorperatuveBg);
export default __webpack_public_path__ + "static/media/coorperatuveBg.0f1bf7ee369b6ddae6a80194847bbb4f.svg";
export { ForwardRef as ReactComponent };